import { Button } from '@cian/ui-kit';
import { IconActionPlus16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

export interface IAddOfferButtonProps {
  onClick(): void;
}

export function AddOfferButton({ onClick }: IAddOfferButtonProps) {
  return (
    <Button
      beforeIcon={<IconActionPlus16 color="icon-main-default" />}
      onClick={onClick}
      size="XS"
      fullWidth
      theme="fill_secondary"
      data-testid="add-offer-button"
    >
      Разместить
    </Button>
  );
}
